/* BUDGET ROW TYPES KEY 
o = order
c = columns
r = rows
v = value
h = is header row
b = bold
t = title
s = subtitle
i = input type{
    "n" = number
    "d" = dollar
  }
tot = include in total
sum = sum the last two columns
*/

const budgetRowTypes = [
  {
    description: "Description, Quantity, Price, Total",
    value: [
      {
        c: [
          { v: "Description" },
          { v: "Quantity" },
          { v: "Price ($)" },
          { v: "Total ($)" }
        ],
        h: true
      },
      {
        c: [
          { v: "" },
          { v: 0, i: "n" },
          { v: 0, i: "d" },
          { v: 0, i: "n", b: true, tot: true, sum: true }
        ]
      }
    ]
  },
  {
    description: "Description, Price",
    value: [
      {
        c: [{ v: "Description" }, { v: "Price" }],
        h: true
      },
      {
        c: [{ v: "" }, { v: 0, i: "d", tot: true }]
      }
    ]
  }
];

export { budgetRowTypes };
